import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

const FilingOptions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Filing Options</h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Comprehensive Federal & State Tax Filing Services
          </h1>
          <p className="tax-section-description">
            At Litax , we provide precise federal and state tax
            filings, along with a full suite of services covering tax planning,
            resolution, audit representation, and business solutions. Our goal
            is to simplify tax compliance while maximizing your financial
            outcomes.
          </p>

          <h2 className="tax-subheading">More Than Just an ERO</h2>
          <p className="tax-section-description">
            As an authorized Electronic Return Originator (ERO), we are licensed
            to prepare and file returns with the IRS and state authorities. But
            our expertise goes far beyond filings—we’re your trusted partner in
            navigating complex tax matters with accuracy and efficiency.
          </p>

          <h2 className="tax-subheading">Our Comprehensive Services</h2>
          <ul className="tax-section-description">
            <li>
              <strong>Tax Planning & Consulting:</strong> Strategies to minimize
              tax liability and optimize savings.
            </li>
            <li>
              <strong>Tax Resolution:</strong> Professional representation to
              resolve IRS issues and disputes.
            </li>
            <li>
              <strong>Audit Representation:</strong> Full support during audits
              to protect your rights and interests.
            </li>
            <li>
              <strong>International Tax Services:</strong> Guidance on cross-border
              compliance and global tax strategies.
            </li>
            <li>
              <strong>Business Tax Services:</strong> From bookkeeping and
              payroll to entity selection and corporate tax planning.
            </li>
          </ul>

          <h2 className="tax-subheading">Your One-Stop Tax Solution</h2>
          <p className="tax-section-description">
            We don’t just file forms—we act as your tax advisors. Our team is
            here year-round to answer questions, address concerns, and ensure
            you make informed financial decisions with confidence.
          </p>

          <h2 className="tax-subheading">Start Your Stress-Free Tax Journey</h2>
          <p className="tax-section-description">
            Don’t let taxes become a burden. With Litax , you’ll have
            a reliable partner guiding you every step of the way.{" "}
            <strong>
              Contact us today to explore the right filing option for you and
              experience hassle-free, accurate tax management.
            </strong>
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default FilingOptions;
